import { render } from "./AposColorInfo.vue?vue&type=template&id=3ef1feb6"
import script from "./AposColorInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./AposColorInfo.vue?vue&type=script&setup=true&lang=js"

import "./AposColorInfo.vue?vue&type=style&index=0&id=3ef1feb6&lang=scss"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"color-field/ui/apos/lib/AposColorInfo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3ef1feb6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3ef1feb6', __exports__)) {
    api.reload('3ef1feb6', __exports__)
  }
  
  module.hot.accept("./AposColorInfo.vue?vue&type=template&id=3ef1feb6", () => {
    api.rerender('3ef1feb6', render)
  })

}


export default __exports__